<template>
  <div class="video-player">
    <v-row class="mx-0 my-5 pt-10">
      <v-col style="text-align:center">
        <span class="ct-text-subtitle sectTitle2">{{ title }}</span>
      </v-col>
    </v-row>
    <v-container class="content-detail">
      <v-row justify="center" data-aos="fade-up">
        <v-col cols="12" md="12" lg="10">
          <div class="video-wrapper">
            <div class="video-container">
              <iframe
                :src="videoUrl"
                :title="videoTitle"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                :aria-label="videoAriaLabel"
                role="application"
                tabindex="0"
              ></iframe>
            </div>
            <div class="video-description" v-if="description">
              <p class="item-description">{{ description }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "影片介紹"
    },
    videoId: {
      type: String,
      required: true
    },
    videoTitle: {
      type: String,
      default: "碳匯相關影片"
    },
    description: {
      type: String,
      default: ""
    }
  },
  computed: {
    videoUrl() {
      return `https://www.youtube.com/embed/${this.videoId}`;
    },
    videoAriaLabel() {
      return `${this.videoTitle}，YouTube 影片播放器`;
    }
  }
};
</script>

<style lang="scss" scoped>
.video-player {
  padding: 2rem 0;

  .content-detail {
    padding: 2rem 0;
  }

  .video-wrapper {
    padding: 1rem;
  }

  .video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 比例 */
    height: 0;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: #000;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;

      &:focus {
        outline: 3px solid #4caf50;
        outline-offset: 2px;
      }
    }
  }

  .video-description {
    margin-top: 1.5rem;
    padding: 1rem;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    text-align: center;
  }

  .item-description {
    font-size: 1rem;
    line-height: 1.6;
    color: #333;
    margin: 0;
  }
}

.sectTitle2 {
  display: inline-block;
  font-size: 1.8rem;
  font-weight: bold;
  color: #2d5016;
}
</style>
